import React from 'react';

import styled from 'styled-components';

export default function Product() {
  return (
    <StyledProduct>
      <StyledIqStudio>
        <div>
          <StyledProductNumber>01</StyledProductNumber>
          <StyledProductNameContainer>
            <StyledProductName>
              IntelliQuant Studio
              <StyledIqStudioPointer
                href="https://intelliquant.ai"
                target="_blank"
              >
                <img
                  alt="pointer"
                  src="images/Home/product/pointer/group-2@3x.png"
                />
              </StyledIqStudioPointer>
            </StyledProductName>
          </StyledProductNameContainer>
          <StyledProductDescription>
            IQ Studio는 전문적인 퀀트 투자를 개인 투자자도 가능하게 만드는
            서비스입니다.
            <br />
            복잡하고 정교한 데이터 수집부터 백테스트 성과분석, 자동매매까지
            <br />
            퀀트 전략 개발에 필요한 모든 기술적 장벽을 허무는 것을 목표로
            합니다.
          </StyledProductDescription>
        </div>
        <StyledIqStudioImage />
        <StyledMobileIqStudioImage
          alt="iqstudio mobile image"
          src="images/Home/product/iqstudio/mobile/group-41@3x(mobile).png"
        />
        <StyledMobileProductDescription>
          IQ Studio는 전문적인 퀀트 투자를 개인 투자자도 가능하게 만드는
          서비스입니다.
          <br />
          복잡하고 정교한 데이터 수집부터 백테스트 성과분석, 자동매매까지
          <br />
          퀀트 전략 개발에 필요한 모든 기술적 장벽을 허무는 것을 목표로 합니다.
        </StyledMobileProductDescription>
      </StyledIqStudio>
      <StyledIqon>
        <div>
          <StyledProductNumber>02</StyledProductNumber>
          <StyledProductNameContainer>
            <StyledProductName>
              iQon
              <StyledIqonPointer
                href="https://intelliquanthq.notion.site/Pro-252fc4046ef84924bda9c942bccb6b10"
                target="_blank"
              >
                <img
                  alt="pointer"
                  src="images/Home/product/pointer/group-2@3x.png"
                />
              </StyledIqonPointer>
            </StyledProductName>
          </StyledProductNameContainer>
          <StyledProductDescription>
            iQon은 인텔리퀀트팀의 모든 정수가 담긴 로보어드바이저 서비스 입니다.
            <br />
            돈을 다루는 알고리즘이지만, 항상 그 너머에 있는 투자자를 최우선으로
            생각합니다.
            <br />
            알고리즘을 통한 모든 이들의 경제적 자유 달성. iQon의 존재 이유이자
            궁극적인 목표입니다.
          </StyledProductDescription>
        </div>
        <StyledIqonImage />
        <StyledMobileIqonImage
          alt="iqon mobile image"
          src="images/Home/product/iqon/group-25@3x.png"
        />
        <StyledMobileProductDescription>
          iQon은 인텔리퀀트팀의 모든 정수가 담긴 로보어드바이저 서비스 입니다.
          <br />
          돈을 다루는 알고리즘이지만, 항상 그 너머에 있는 투자자를 최우선으로
          생각합니다.
          <br />
          알고리즘을 통한 모든 이들의 경제적 자유 달성. iQon의 존재 이유이자
          궁극적인 목표입니다.
        </StyledMobileProductDescription>
      </StyledIqon>
      <StyledCryptoQuant>
        <div>
          <StyledProductNumber>03</StyledProductNumber>
          <StyledProductNameContainer>
            <StyledProductName>
              Crypto-asset Platform
              <StyledCryptoPointer href="https://btcsaving.io/" target="_blank">
                <img
                  alt="pointer"
                  src="images/Home/product/pointer/group-2@3x.png"
                />
              </StyledCryptoPointer>
            </StyledProductName>
          </StyledProductNameContainer>
          <StyledProductDescription>
            <strong>Prism</strong>
            <br />
            Prism은 거래소 간에 상이한 가격, 단일 거래소의 유동성이 부족한
            문제를 해결하기 위해 만든 트레이딩 솔루션입니다.
            <br />
            Prism을 통해 최적의 가격으로 다중 거래소의 유동성을 모두 통합한 주문
            집행으로 해결할 수 있습니다.
          </StyledProductDescription>
          <StyledProductDescription>
            <strong>BiQon</strong>
            <br />
            BiQon은 디지털자산 투자자를 위한 로보어드바이저 서비스입니다.
            <br />
            변동성이 큰 디지털자산 시장에서 안정적이고 꾸준한 수익을 최우선으로
            한 맞춤형 운용을 목표로 합니다.
          </StyledProductDescription>
        </div>
        <StyledCryptoQuantImage />
        <StyledMobileCryptoQuantImage
          alt="cryptoQuant mobile image"
          src="images/Home/product/cryptoquant/group-31@3x.png"
        />
        <StyledMobileProductDescription>
          <strong>Prism</strong>
          <br />
          Prism은 거래소 간에 상이한 가격, 단일 거래소의 유동성이 부족한 문제를
          <br />
          해결하기 위해 만든 트레이딩 솔루션입니다.
          <br />
          Prism을 통해 최적의 가격으로 다중 거래소의 유동성을 <br />
          모두 통합한 주문 집행으로 해결할 수 있습니다.
        </StyledMobileProductDescription>
        <StyledBiQonMobileProductDescription>
          <strong>BiQon</strong>
          <br />
          BiQon은 디지털자산 투자자를 위한 로보어드바이저 서비스입니다.
          <br />
          변동성이 큰 디지털자산 시장에서 안정적이고 꾸준한 수익을 <br />
          최우선으로 한 맞춤형 운용을 목표로 합니다.
        </StyledBiQonMobileProductDescription>
      </StyledCryptoQuant>
    </StyledProduct>
  );
}

const StyledProduct = styled.article`
  padding-top: 151px;
  margin-bottom: 200px;
  overflow-x: hidden;

  ${({ theme }) => theme.mobile`
    text-align: center;
    margin-bottom: 96px;
    padding: 70px 30px 0;
  `}
`;

const StyledProductDescription = styled.p`
  display: block;

  ${({ theme }) => theme.mobile`
    display: none;
  `}
`;

const StyledMobileProductDescription = styled.p`
  display: none;
  font-size: ${({ theme }) => theme.pixelToRem(14)};

  ${({ theme }) => theme.mobile`
    display: block;
  `}
`;

const StyledBiQonMobileProductDescription = styled(
  StyledMobileProductDescription
)`
  margin-top: 20px;
`;

const StyledProductNumber = styled.h2`
  -webkit-text-fill-color: ${({ theme }) => theme.colors.pureWhite};
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: ${({ theme }) => theme.colors.green};
  font-size: ${({ theme }) => theme.pixelToRem(50)};
  font-weight: 700;

  ${({ theme }) => theme.mobile`
    font-size: ${({ theme }) => theme.pixelToRem(30)};
  `}
`;

const StyledProductNameContainer = styled.div``;

const StyledProductName = styled.h3`
  margin-bottom: 34px;
  position: relative;
  font-size: ${({ theme }) => theme.pixelToRem(50)};
  font-weight: 300;

  ${({ theme }) => theme.mobile`
    margin-bottom: 28px;
    font-size: ${({ theme }) => theme.pixelToMobileVw(30)};
  `}
`;

const StyledIqStudioPointer = styled.a`
  img {
    position: absolute;
    width: 200px;
    bottom: -40%;
    transition: transform 0.3s;
    transform-origin: 40% 60%;
    cursor: pointer;

    &:hover {
      transform: scale(1.5);
    }

    ${({ theme }) => theme.mobile`
    width: 35vw;
    bottom: -135%;
    right: -30vw;

    &:hover {
      transform: scale(1.2);
    }
  `};
  }
`;

const StyledIqonPointer = styled(StyledIqStudioPointer)``;

const StyledCryptoPointer = styled(StyledIqStudioPointer)``;

const StyledIqStudio = styled.div`
  ${({ theme }) => theme.flex('row', 'center', 'flex-start')}
  margin: 0 0 200px 16%;

  div:first-child {
    margin-right: 142px;

    ${({ theme }) => theme.mobile`
      margin-right: 0;
    `}
  }

  ${({ theme }) => theme.mobile`
  ${({ theme }) => theme.flex('column')};
  margin: 0 0 96px 0;
  `}
`;

const StyledIqStudioImage = styled.div`
  display: block;
  width: 930px;
  height: 500px;
  background-image: url('images/Home/product/iqstudio/group-41@3x.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right -10% bottom 45%;

  ${({ theme }) => theme.mobile`
  display: none;
  `}
`;

const StyledMobileIqStudioImage = styled.img`
  display: none;
  width: 70%;
  margin-bottom: 28px;

  ${({ theme }) => theme.mobile`
    display: block;
  `}
`;

const StyledIqon = styled.div`
  ${({ theme }) => theme.flex('row', 'center', 'flex-start')}
  display: flex;
  margin: 0 0 200px 8%;

  div:first-child {
    margin-right: 178px;

    ${({ theme }) => theme.mobile`
      margin-right: 0;
    `}
  }

  ${({ theme }) => theme.mobile`
  ${({ theme }) => theme.flex('column')};
  margin: 0 0 96px 0;

  .iQonPointer{
      width: 90%;
    }
    
  `}
`;

const StyledIqonImage = styled.div`
  display: block;
  width: 500px;
  height: 500px;
  background-image: url('images/Home/product/iqon/group-25@3x.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: left 23% bottom 45%;

  ${({ theme }) => theme.mobile`
    display: none;
  `}
`;

const StyledMobileIqonImage = styled.img`
  display: none;
  width: 30%;
  margin-bottom: 28px;

  ${({ theme }) => theme.mobile`
    display: block;
  `}
`;

const StyledCryptoQuant = styled.div`
  ${({ theme }) => theme.flex('row', 'center', 'flex-start')}
  margin-left: 200px;

  div:first-child {
    margin-right: 140px;

    p {
      margin-bottom: 30px;
    }

    ${({ theme }) => theme.mobile`
      margin-right: 0;
    `}
  }

  ${({ theme }) => theme.mobile`
  ${({ theme }) => theme.flex('column')};
  margin: 0;
  `}
`;

const StyledCryptoQuantImage = styled.div`
  display: block;
  width: 588px;
  height: 500px;
  background-image: url('images/Home/product/cryptoquant/group-31@3x.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: left 30% bottom 45%;

  ${({ theme }) => theme.mobile`
    display: none;
  `}
`;

const StyledMobileCryptoQuantImage = styled.img`
  display: none;
  width: 60%;
  margin-bottom: 28px;

  ${({ theme }) => theme.mobile`
    display: block;
  `}
`;
